var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnter42 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 42,
  height: 42,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M32.5 8h-16v1h16a2.5 2.5 0 0 1 2.5 2.5v13a2.5 2.5 0 0 1-2.5 2.5H8.707l7.5-7.5-.707-.707L6.793 27.5l8.707 8.707.707-.707-7.5-7.5H32.5a3.5 3.5 0 0 0 3.5-3.5v-13A3.5 3.5 0 0 0 32.5 8Z",
  clipRule: "evenodd"
})));
export { SvgEnter42 as ReactComponent };
export default __webpack_public_path__ + "3e5447b9d3926f02a5d4e87d3aad6311.svg";